import React,{ useEffect, useState } from 'react';
import useLocalStorageState from 'use-local-storage-state';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
const Joblisting = () => {  
  const [token, setToken] = useLocalStorageState('token', '');
  const [data, setData] = useState([]);  
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(<div style={{paddingTop:'200px'}}> <center><Spinner animation="grow" variant="primary" />
  <Spinner animation="grow" variant="secondary" />
  <Spinner animation="grow" variant="success" />
  <Spinner animation="grow" variant="danger" />
  <Spinner animation="grow" variant="warning" />
  <Spinner animation="grow" variant="info" />
  <Spinner animation="grow" variant="light" />
  <Spinner animation="grow" variant="dark" /></center> </div>);    
  const LoadJobList =async()=>
    {
      setLoading(true);
      let endpoint = process.env.REACT_APP_PHP_URL+'jobs';
        const BEARER_TOKEN = token;
          try {
            const response = await axios(endpoint, {
              method: "GET",
              withCredentials: true,
              headers: {
                'Authorization': `Bearer ${BEARER_TOKEN}`,
                'Content-Type': 'application/json',
              },
            });
            setData(response.data.data);
            setLoading(false);
          } catch (error) {
           // console.error("Error fetching data:", error);
            setLoading(false);
          }
    }
function dateConvertion(date)
	{
	if (!date || date.trim() === '') {
		return ''; 
	}
  	let cstdate = '';
	try {
		const myArray = date.split(" ");
		const dt = myArray[0].split("/");
		cstdate = dt[0] + '/' + dt[1] + '/' + dt[2] ;
		} catch (error) {			
			console.error("Error formatting date:", error);
			return '';
		}
  	return cstdate;
	}
  useEffect(() => {
    LoadJobList();
  },[]);
    return (<><div key="joblist" className="container">
      <div className="row">
      {data.length !== 0 ? (
        data.map((item) => (
          <div className="col-sm-12" key={item.id}>
          <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                <b>{item.business_name}</b>
                </h5>
            <p className="card-text">#{item.po_number}</p>
                <table>
                    <tbody>
                    <tr><td valign="top">Status :&nbsp;</td><td><b>{item.status}<span style={{float: 'right',right: '15px',position: 'absolute'}}>{item.status === 'Ready to collect' ? (dateConvertion(item.collection_date)):(dateConvertion(item.delivery_date))}</span></b></td></tr>
                    {item.collection_address!='' ?<tr style={{height: '7px'}}><td></td></tr>:''}
                    {item.collection_address!='' ? <tr key={'ctr'+item.id}><td style={{width:'30%'}} valign="top">Collection :&nbsp;</td><td>							
                      {item.collection_address.split("\n").map((line, index) => (
        					    <div key={index}><b>{line}</b></div>
      						  ))} </td></tr> : ''}
                    {item.delivery_address!='' ?<tr style={{height: '7px'}}><td></td></tr>:''}
                    {item.delivery_address!='' ? <tr key={'dtr'+item.id}><td style={{width:'30%'}} valign="top">Delivery :&nbsp;</td><td>
                    {item.delivery_address.split("\n").map((line, index) => (
        					    <div key={index}><b>{line}</b></div>
      						  ))}                      
                      </td></tr> : ''}
                      <tr style={{height: '14px'}}><td></td></tr>
                     </tbody>
                </table>
                <a href={'/jobs/'+item.id} className="loginbtn btn btn-primary center">View Job</a>
              </div>              
              <br/>
          </div>
          </div>
          ))
      ):(
        <div className="col-sm-12" key="0">
        {loading && <div>{loader}</div>}
        {!loading && !data &&(<div className="card">
            <div className="card-body">
              <h5 className="card-title">
               <center>No pending jobs available!!</center>
              </h5>
            </div>
        </div>
        )}
        </div>
      ) }
      <div className="col-sm-12"></div>
      </div>
    </div>
    </>);
}
export default Joblisting;